export default __webpack_public_path__ + "static/tick-b3238a07621a0efaef63e496e2dae5d0.wav";